import { BuyerRefNoRequest, CommonResponseModel, IndentDTO, IndentRequestDto, SourcingRequisitionReq, UploadResponse, indentId, indentIdReq } from "@project-management-system/shared-models";
import { CommonAxiosService } from "../common-axios-service-prs";

export class HsnCodeService extends CommonAxiosService {
  URL = "/hsncode";


  async getAllHsnCode(req?:any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getAllHsnCode",req)
  }
  
}
